var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nav',{staticClass:"navigation"},[_c('ul',{staticClass:"nav-container h-full",class:{
			'nav-container--old-design': !_vm.$isBlueBranding,
		}},_vm._l((_vm.menuData),function(navEntry,navEntryIndex){return _c('DesktopNavigationEntry',{key:navEntryIndex,attrs:{"entry":navEntry}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }